import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMap } from "../../../context/map";
import { useRoot } from "../../../context/root";
import { initialValues } from "../dialogs/Filters/utils";

export const useSearchSection = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const { geohash } = useParams();
  const { rootDispatch } = useRoot();
  const { mapContext } = useMap();
  const searchParams = new URLSearchParams(location.search);
  const [openFiltersModal, setOpenFiltersModal] = useState(false);

  const clearSearchParams = () => {
    Object.keys(initialValues).map((key) => {
      searchParams.delete(key)
    })
    searchParams.delete("item_type");
    rootDispatch({
      type: "setIsMapMoving",
      data: false
    })
    rootDispatch({
      type: "setDataList",
      data: []
    });
    rootDispatch({
      type: "setDataMarkers",
      data: []
    });
    rootDispatch({
      type: "setExtraMarker",
      data: null,
      mapContext
    });
    if (geohash) {
      navigator({
        pathname: `${process.env.REACT_APP_INTERNAL_URL}bucket/${geohash}`,
        search: searchParams.toString()
      })
    }
    else {
      navigator({
        pathname: `${process.env.REACT_APP_INTERNAL_URL}`,
        search: searchParams.toString()
      })
    }
    rootDispatch({
      type: "setRefetch",
      data: {
        shouldRefetch: true,
        geohash: geohash || null
      }
    })
  }
  
  return {
    filtersExists: Object.keys(Object.fromEntries(searchParams)).reduce((acc: any, cur: any) => {
      if (cur !== "search_name" && cur !== "item_type" && cur !== "previous" && cur !== "appName" && cur !== "open" && cur !== "next" && cur !== "claim") {
        return [...acc, true]
      } 
      else if (searchParams.get("item_type")) {
        return [...acc, true]
      }
      return acc;
    }, []).length > 0,
    openFiltersModal,
    setOpenFiltersModal,
    clearSearchParams
  }
}
